/*
* CM
* SD-WAN
* SD-WAN 설정
* 프로파일 설정
*
* @since 2022-12-09
* @author wj_tams_dev01
* */

import {CmApiPrefix} from '~/utils/restApi'

const urlPrefix = `${CmApiPrefix}/sdwan/policy`

export const state = () => ({
  profileList: [],
  profileInfo: {
    sdwan_policy_prf_id: 0,
    sdwan_policy_prf_name: '',
    sdwan_default_policy_id: 0,
    sdwan_policy_prf_desc: '',
    sdwan_policy_num: 0,
    sdwan_policy_prf_device: [],
    sdwan_policy_prf_device_str: ''
  }
})

export const mutations = {
  init (state) {
    state.profileList = []
    state.profileInfo = {
      sdwan_policy_prf_id: 0,
      sdwan_policy_prf_name: '',
      sdwan_default_policy_id: 0,
      sdwan_policy_prf_desc: '',
      sdwan_policy_num: 0,
      sdwan_policy_prf_device: [],
      sdwan_policy_prf_device_str: ''
    }
  },
  initProfileList (state, profileList) {
    state.profileList = profileList
  }
}

export const actions = {

  /* 프로파일 전체 조회 */
  async getProfileList ({commit}, {loading = true} = {}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$get(`${urlPrefix}/app-prf`, {loading})
      if (code === 'ok') {
        commit('initProfileList', result)
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },

  /* 프로파일 추가 */
  async addProfile ({commit, state}, {param, loading = true, successAlert = true} = {}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$post(`${urlPrefix}/app-prf`, param, {loading, successAlert})
      if (code === 'ok') {
        res.result = result
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },

  /* 프로파일 수정(편집) */
  async updateProfile ({state}, {param, loading = true, successAlert = true} = {}) {
    let res = {code: 'ok'}
    try {
      const {
        code, result
      } = await this.$axios.$put(`${urlPrefix}/app-prf/${param.sdwan_policy_prf_id}`, param, {loading, successAlert})
      if (code === 'ok') {
        res.result = result
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },

  /* 프로파일 삭제 */
  async deleteProfile ({state}, param) {
    let res = {code: 'ok'}
    try {
      const {
        code,
        result
      } = await this.$axios.$delete(`${urlPrefix}/app-prf`, {
        data: param,
        successAlert: false,
        loading: false
      })
      if (code !== 'ok') {
        res = {code: 'nok', reason: result.msg}
      } else if (_.isArray(result)) {
        res.result = result
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },

  /* 프로파일 및 정책 적용/취소 */
  async finalCommand ({state}, type) {
    let res = {code: 'ok'}
    const apiUri = `${urlPrefix}/app-prf/${type}`,
      axiosConfig = (type === 'apply') ? {applyMsg: true} : {cancelMsg: true}
    try {
      const result = await this.$axios.$put(apiUri, void 0, axiosConfig)
      res = result
    } catch (e) {
      res = {code: 'nok', result: {msg: e}}
    }
    return res
  }
}
